import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWandMagicSparkles } from "@fortawesome/pro-solid-svg-icons";
import { faHouse } from "@fortawesome/pro-regular-svg-icons";


import Card from "@/components/card/index.tsx";
import ButtonLockDependent from "@/components/buttons/button-lock-dependent";

interface Calcul1PdfsimpleCardActionProps {
    storeysFileDataHasScale: boolean;
    isLoading: boolean;
    onClick: () => void;
}

const Calcul1PdfsimpleCardAction: React.FC<Calcul1PdfsimpleCardActionProps> = ({
    storeysFileDataHasScale,
    isLoading,
    onClick
}) => 
    (
        <>
            <Card additionalContentClasses='flex flex-col gap-y-2 px-4 py-2 text-sm'>
                <ButtonLockDependent variant='simple' size='sm'
                    onClick={onClick}
                    disabled={isLoading || !storeysFileDataHasScale}>
                    <div className='flex flex-row gap-x-2 items-center'>
                        <div className='flex flex-row gap-x-1 items-baseline'>
                            <FontAwesomeIcon icon={faHouse} />
                            <FontAwesomeIcon icon={faWandMagicSparkles} />
                        </div>
                        <span>Calcul automatique</span>
                    </div>
                </ButtonLockDependent>

                <div>
                    <span>Obtenez automatiquement</span>
                    <ul className='list-disc list-inside pl-2 text-sm'>
                        <li>Murs intérieurs</li>
                        <li>Murs extérieurs</li>
                        <li>Dalles</li>
                        <li>Pièces gros-œuvre</li>
                    </ul>
                </div>
            </Card>
        </>
    );

export default Calcul1PdfsimpleCardAction;